import { NOOP } from '@/utils';

import { ColumnTypes } from '..';

export const getColumns = (length: number): ColumnTypes => [
	{
		title: `NO.`,
		dataIndex: 'no',
		key: 'no',
		align: 'center',
		render(value, record, index) {
			return length ? length - index : 0;
		},
	},
	{
		title: '프로그램',
		dataIndex: 'programName',
		key: 'programName',
		align: 'center',
	},
	{
		title: '시작일',
		dataIndex: 'programStartDate',
		key: 'programStartDate',
		align: 'center',
	},
	{
		title: '종료일',
		dataIndex: 'programEndDate',
		key: 'programEndDate',
		align: 'center',
	},
];

export const TriggerOpenJoinProgramModal = {
	show: NOOP,
};
